// lib
import { useContext, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/question-views/xq/Component'

// components
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'

// styles
import style from '@aytm/app/stats/page/question-views/xq/styles/ScriptItem.module.scss'

const ScriptItemSelect = ({ item, value, multiple }) => {
  const { model, disabled, onChange } = useContext(DataContext)
  const titleId = `stat-xq-${model?.id}-arg-${item?.id}-title`

  const itemOptions = useMemo(
    () => item.options.map(r => (r instanceof Object ? { key: r.value, text: r.text } : { key: r, text: r })),
    [item.options]
  )

  const onValueChange = useCallback(
    option => {
      const options = Array.isArray(option)
        ? option.map(r => (r instanceof Object ? r.value : r))
        : option instanceof Object
        ? option.value
        : option

      // Compare by content, not identity — multi-select values are distinct array instances each render
      if (JSON.stringify(value) === JSON.stringify(options)) return

      model.args[item.id] = options
      onChange(model)
    },
    [item.id, value, model, onChange]
  )

  return (
    <div data-testid={`stat-xq-arg-${item?.id}`} className={style.item}>
      {disabled ? (
        <div
          className="p-col-12"
          dangerouslySetInnerHTML={{ __html: Array.isArray(value) ? value.join(', ') : value }}
        />
      ) : (
        <>
          <div
            id={titleId}
            className={`${style['item-title']} p-col-4`}
            dangerouslySetInnerHTML={{ __html: item.text || item.id }}
          />
          <div className="p-fluid p-col-8">
            {multiple ? (
              <MultiSelect
                className="p-multiselect-rounded"
                aria-labelledby={titleId}
                placeholder="Select..."
                value={value}
                options={itemOptions}
                optionValue="key"
                optionLabel="text"
                maxSelectedLabels={1}
                fixedDropdownDir="bottom"
                showSelectAll={false}
                onChange={event => onValueChange(event.value)}
              />
            ) : (
              <Dropdown
                className="p-dropdown-rounded"
                aria-labelledby={titleId}
                placeholder="Select..."
                value={value}
                options={itemOptions}
                optionValue="key"
                optionLabel="text"
                fixedDropdownDir="bottom"
                onChange={event => onValueChange(event.value)}
              />
            )}
          </div>
        </>
      )}
    </div>
  )
}

ScriptItemSelect.propTypes = {
  item: PropTypes.object,
  value: PropTypes.any,
  multiple: PropTypes.bool
}

ScriptItemSelect.displayName = 'ScriptItemSelect'

export default ScriptItemSelect
